
export interface CoreMeitnerExportConfiguration {
    id: string
    moduleId: string
    environment: MeitnerExportEnvironmentType
    clientId?: string
    clientSecret?: string
    groupTypes: MeitnerGroupTypes
    sendModerators: boolean
    employeeConfiguration: CoreMeitnerUserConfiguration
    studentConfiguration: CoreMeitnerUserConfiguration
    guardianConfiguration: CoreMeitnerUserConfiguration
    meitnerSchoolUnits: CoreMeitnerExportSchoolUnit[] | []
}

export enum MeitnerExportEnvironmentType {
    Unknown = 0,
    Staging = 1,
    Production = 2,
}

export const meitnerExportEnvironmentTypeOptions: MeitnerExportEnvironmentType[] = [
    MeitnerExportEnvironmentType.Staging,
    MeitnerExportEnvironmentType.Production
]

export enum MeitnerGroupTypes {
    //Ingen
    None = 0x0000,
    //Klass
    Class = 0x0001,
    //Avdelning
    Childcare = 0x0002,
    //Mentor
    Mentor = 0x0004,
    //Education
    Education = 0x0008
}

export const meitnerExportGroupTypesOptions: MeitnerGroupTypes[] = [
    MeitnerGroupTypes.Class,
    MeitnerGroupTypes.Childcare,
    MeitnerGroupTypes.Mentor,
    MeitnerGroupTypes.Education

]

export enum MeitnerMobilePhoneNumberExportType {
    Never = 0,
    OnCreation = 1,
    Always = 2
}

export const meitnerMobilePhoneNumberExportTypeOptions: MeitnerMobilePhoneNumberExportType[] = [
    MeitnerMobilePhoneNumberExportType.Never,
    MeitnerMobilePhoneNumberExportType.OnCreation,
    MeitnerMobilePhoneNumberExportType.Always
]

export interface CoreMeitnerUserConfiguration {
    sendAddress: boolean
    sendEmailAddress: boolean
    sendTelephoneNumber: boolean
    sendMobilePhoneNumber: MeitnerMobilePhoneNumberExportType
    gracePeriod: number | null
}

export interface CoreMeitnerExportSchoolUnit {
    id?: string
    meitnerSchoolUnitId: string
    meitnerExportId: string
    displayName: string
    meitnerExportSchoolUnitMaps?: CoreMeitnerExportSchoolUnitMap[]
}

export interface CoreMeitnerExportSchoolUnitMap {
    meitnerExportSchoolUnitId?: string
    flowSyncSchoolUnitId: string
}

export interface MeitnerSchoolUnitResponse {
    items: MeitnerSchoolUnit[]
    pagination: {
        limit: number
        offset: number
        total: number
    }
}

export interface MeitnerSchoolUnit {
    id: string
    title: string
}